import Banner from "../Banner/Banner"
import styled from "styled-components"
import NavBar from "../NavBar/NavBar";
import ContentArea from "../ContentArea/ContentArea";
import FooterBan from "../FooterBan/FooterBan";
import PageProvider, { PageContext } from "../Context/PageContext";
import PopMenuWindow from "../PopMenuWindow/PopMenuWindow";
import Tooltip from "../Tooltip/Tooltip";
import MusicPlayerMedia from "../MusicPlayer/MusicPlayerMedia";
import { useContext, useEffect, useState } from "react";
import { ApiConnectWelcomeBackSession } from "../api/LionsUserApiConect";
import UserNotLogged from "../ContentArea/Dashboard/DashboardItems/UserNotLogged";
import Dashboard from "../ContentArea/Dashboard/Dashboard";
import NavBarMobile from "../NavBar/NavBarMobile";
import NavBarNew from "../NavBar/NavBarNew";
import { BrowserRouter } from "react-router-dom";
import MobShowToolTip from "../ContentArea/Database/MobShowToolTip";
import VoteWidget from "../VoteWidget/VoteWidget";


function MainContainer(){

    const { setIsLogged, setUser, setDashboardInitialPage } = useContext(PageContext);
    const [navBarType, setNavBarType] = useState(<NavBarNew/>)

    const [musicPlayer, setMusicPlayer] = useState(<VoteWidget/>);


    
        useEffect(()=>{
            let result = ApiConnectWelcomeBackSession();
                result.then((response) => {

                    if(response.status == 403 || response.status == 401) {
                            setDashboardInitialPage(<UserNotLogged />);
                            setIsLogged(false);
                            return;
                        } else {
                            setDashboardInitialPage(<Dashboard />);
                            setIsLogged(true);
                            setUser(response.data)
                        }
                })

                if(window.screen.width < 1000) {
                    setNavBarType(<NavBarMobile/>);
                    setMusicPlayer(<></>);
                }
        },[])

    return(  
            <>
                <Tooltip />
                <MobShowToolTip />
                <PopMenuWindow PopMenuId={"PopMenuWindow"}/>
                <MainContentContainerBox>
                    <BrowserRouter>
                    <>
                        {navBarType}
                        <Banner />
                        <ContentArea />
                    </>
                    <FooterBan />
                    </BrowserRouter>
                </MainContentContainerBox>
                {musicPlayer}
            </>
            
    );
};


const Master = styled.div`
 
`;

const MainContentContainerBox = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    //border: solid 2px black;
    //width: 1280px;
    //min-height: 2000px;
    transition: .3s ease-in-out;
    position: relative;
    justify-content: space-between;

    @media (max-width: 1000px) {
    width: 100vw;
    //border: solid;
    }
`;

export default MainContainer;